__webpack_require__.p = "/ton-widget/";